<template>
  <div class="club-card" @click="setSelectedClub(club.id)">
    <div class="img">
      <img :src="club.imageUrl" alt="" />
    </div>
    <div class="info">
      <div class="club-name">{{ club.name }}</div>
      <div class="club-props">
        <span v-for="service in club.services" :key="service.id" class="prop">{{
          service.name
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "ClubCard",
  props: ["club"],
  methods: {
    ...mapActions(["selectClub"]),
    setSelectedClub(id) {
      this.selectClub(id);
      this.$router.push({ name: "Home" });
    }
  }
};
</script>

<style scoped>
.club-card {
  width: 100%;
  border-radius: 5px;
  overflow: hidden;
  background: #e30614;
  color: #fff;
  text-align: left;
  margin-bottom: 1em;
  cursor: pointer;
}
.club-card:last-of-type {
  margin-bottom: 0;
}
.info {
  display: flex;
  padding: 13px 10px 15px 10px;
}
.club-name {
  flex: 2;
  font-weight: bold;
}
.prop {
  font-size: 10px;
  padding-right: 8px;
}
.prop:last-of-type {
  padding-right: 0px;
}
.prop:not(:last-of-type)::after {
  content: "|";
  position: relative;
  right: -4px;
  font-size: 13px;
  top: 1px;
}
@media (min-width: 601px) {
  .club-card {
    max-width: 48%;
  }
  .info {
    display: block;
  }
  .club-card:last-of-type {
    margin-bottom: 1em;
  }
}
@media (min-width: 1025px) {
  .club-card {
    max-width: 33%;
  }
}
</style>
